import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Card, CardBody, Button } from 'reactstrap';
import { Popover } from 'antd';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import Axios from 'axios';
import Swal from 'sweetalert2';

import Loader from '../../Global/Loader';
import ContentWrapper from '../../template/Layout/ContentWrapper';

import { Services } from "../../../repositories/clients/Services";
import Table from './../Components/Table';

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchOnInit: false,
      activePage: 1,
      data: [],
      searchText: '',
      loadingInfo: true,
      AddUser: <div className='float-right'  >
        <div style={{
          alignItems: "center",
          display: "inline-flex"
        }}>

          <i className='fas fa-plus-circle fa-2x buton-add' onClick={() => { this.addUser() }} />

          {/* 
          <img style={{
            cursor: "pointer"
          }} src={IMG_ADD} width="28" height="28" onClick={() => { this.addUser() }} /> */}
          <span style={{ marginLeft: "10px", fontWeight: "bold" }} className='tag-custom-value'>{this.props.t("create_new")}</span>
        </div>


      </div>,
      columns: [


        {
          label: 'ID', key: 'UserId',
          minWidth: 60, maxWidth: 60,
          custom: (value) => (
            <span className='linkDetail' onClick={() => { this.editRow(value) }}>
              {value.UserId}
            </span>
          )
        },
        { label: this.props.t("first_name"), key: 'Name', minWidth: 130 },
        { label: this.props.t("last_name"), key: 'LastName', minWidth: 130 },
        { label: this.props.t("job_role"), key: 'Role', minWidth: 150 },
        { label: this.props.t("job_position"), key: 'Position', minWidth: 150 },
        { label: this.props.t("email"), key: 'Email', minWidth: 300, maxWidth: 300 },
        { label: this.props.t("phone"), key: 'Telephone', minWidth: 150 },
        { label: this.props.t("create_date"), key: 'CreateDate', minWidth: 150 },
        { label: this.props.t("associated_customers"), key: 'AssociatedEntities', minWidth: 150 },
        {
          label: '', key: '', minWidth: 30, maxWidth: 30,
          custom: (value) => {
            return <Popover
              onOpenChange={this.handlePopChange(value)}
              placement="left"
              trigger="hover"
              open={value.showPop}
              className='delete-toolt'
              title={<div><hr className='hr-popover' style={{ width: "101.5%", marginTop: "-.8vh", marginLeft: "-1vw" }}></hr></div>}
              content={() => {
                return (
                  <div>

                    <div className="row">
                      <div
                        className="col-12"
                        style={{

                          textAlign: 'center',
                        }}>
                        <p class="seacargo-pop-icon"><em class="fas fa-exclamation-triangle"></em></p>
                        <p>
                          {this.props.t("sure_delete_user")}
                        </p>
                      </div>

                      <div
                        className="col-12"
                        style={{ textAlign: 'center' }}>
                        <Button
                          content="OK"
                          // negative={false}

                          style={{
                            color: 'white',

                            backgroundColor: "#085fb0"
                          }}
                          color="primarypop"

                          onClick={() => this.deleteUser(value)}
                        >{this.props.t("yes")}</Button>
                        <Button
                          content={this.props.t("cancel")}
                          // negative={false}
                          style={{
                            marginLeft: "10px"

                          }}
                          color="secondpop"
                          onClick={() => { this.handleCancel(value) }}
                        >No</Button>
                      </div>
                    </div>
                  </div>
                );
              }}
            >
              <em onClick={''} style={{ color: '#FF0000', marginLeft: '10%', marginTop: ' 4px', fontSize: "20px" }}
                className="fa-2x mr-2 fas fa-trash-alt"></em>

            </Popover>
          }
        }
      ],
    }
  }


  componentDidMount = () => {
    this.getUserList();

  }
  sendMessage = (text, type) => {
    Swal.fire({
      icon: type,
      confirmButtonColor: "#085fb0",
      confirmButtonText: "Ok",
      html: `<div class="text-center">
      ${text}
      </div>`,
    });
  }
  deleteUser = (value) => {

    let id = value.UserId;
    Axios.delete(`${Services.ADMIN.path}admin/deleteUser/${id}`).then(response => {
      this.sendMessage(this.props.t("user_deleted"), "success");

      this.getUserList();

    }).catch((error) => {
      if (error.response) {
        var mensaje = "";
        if (error.response.data.data) {
          mensaje = error.response.data.data.message;
        } else {
          mensaje = error.response.data.message;
        }
        this.sendMessage(mensaje, "error");
      }


    })
  }

  getUserList = async () => {
    let { data } = this.state;
    await Axios.get(`${Services.ADMIN.path}admin/users`).then(response => {
      data = response.data.data
      data.forEach((d) => {
        d.showPop = false;
      })
    }).catch(error => {

    })
    this.setState({ data, loadingInfo: false, activePage: 1 });
  }

  updateActivePage = (activePage) => {
    this.setState({ activePage });
  }

  addUser = () => {
    this.props.history.push("/altausuario");
  }


  handleCancel = (value) => {
    let { data } = this.state;
    data.forEach((d) => {
      if (value.UserId === d.UserId) {
        d.showPop = false;
      }

    })
    this.setState({
      data
    });
  }
  handlePopChange = (value) => visible => {
    let { data } = this.state;
    data.forEach((d) => {
      if (value.UserId === d.UserId) {
        d.showPop = visible;
      }

    })
    this.setState({
      data
    });
  };

  editRow = (data) => {
    this.props.history.push(`/altausuario/${data.UserId}`);

  }
  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    let { columns, data, searchOnInit, searchText, loadingInfo } = this.state;
    return loadingInfo ? (
      <Loader />
    ) : (
      <ContentWrapper>
        <div className="content-heading">
          {/* <Row> */}
          <legend className="legendBasic">
            {/* <img
              style={{ margin: '-6px 6px 1px' }}
              alt=""
              src="https://magiclog.blob.core.windows.net/europartnerspic/Icono_administracion.svg"
              height="28"
              width="28"
            ></img> */}


            <i className="demo-icon icon-final-19"></i>
            {this.props.t("admin_users")}
          </legend>
          {/* </Row> */}
        </div>
        <Card className="myCard">
          <CardBody>
            <Table
              columns={columns}
              data={data}
              nameXlsx={"Users_list.xlsx"}
              itemsByPage={10}
              name="UserList"
              modalName="ui Modal body order list"
              customer={this.props._customer}
              user={this.props._user}
              customAdd={this.state.AddUser}
              updateActivePage={this.updateActivePage}
              activePage={this.state.activePage}
              // info={
              //   {

              //     // config: columnsConfig
              //     config: {
              //       title: fechaDescarga,
              //       titlePosition: {
              //         col: 11,
              //         row: 5

              //       }

              //     }
              //   }
              // }
              rowClick={false}
              customClick={this.editRow}
              options={
                {

                  pagination: true,
                  search: true,
                  panel: false,
                  downloads: {
                    xlsx: true,
                    pdf: false
                  },
                  sheetName: 'Users',
                  selectItems: false,
                  orderAttention: {
                    activeFilter: searchOnInit,
                    activeText: searchText,
                    search: true,
                    xlsx: false
                  },
                  trigger: this.selectedOrder,
                  searchKeys: [
                    "UserId",
                    "Name",
                    "LastName",
                    "Role",
                    "Position",
                    "Email",
                    "Telephone",
                    "CreateDate",
                    "AssociatedEntities"
                  ]

                }
              }
              cellType={'thick-rows'}
            />
          </CardBody>
        </Card>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(withRouter(Admin)));